import React from 'react';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
} from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';
import { useCreateParentCorporate } from 'src/components/enterprise/features/Corporate/ParentCorpCreatePage/hooks/useCreateParentCorp';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { CorporateFieldsProvider } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/CorporateFieldsProvider';
import { corporateFormDefaultValues } from 'src/components/enterprise/features/Corporate/components/Form/constants/CorporateDefaultValues';
import { CorporateForm } from 'src/components/enterprise/features/Corporate/components/Form/CorporateForm';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { getWindow } from 'src/utilities/window';
import { CreateCorpResponse } from 'src/types/Corp';

export const ParentCorpCreatePage: React.FC = () => {
  const window = getWindow();
  const onSuccess = async (corpData: CreateCorpResponse): Promise<void> => {
    window.location.href = `${window.location.origin}/groupadmin/parents/${corpData.id}`;
  };
  const onError = async (
    error: IErrorResponse | SdkErrorResponse
  ): Promise<void> => {
    pushErrorFromAPI(error);
  };
  const { createParentCorp } = useCreateParentCorporate({
    onSuccess,
    onError,
  });

  const parentAccountDescription =
    'Information and settings made on this page will apply to all child accounts created under this parent account.';

  return (
    <Square inset="lg">
      <PageHeader>
        <PageTitle title="Create new parent account" />
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Parent accounts',
              href: `/groupadmin/parents`,
            },
          ]}
        />
      </PageHeader>
      <Stack y="sm">{parentAccountDescription}</Stack>
      <CorporateFieldsProvider>
        <CorporateForm
          defaultValues={corporateFormDefaultValues}
          onSubmit={createParentCorp}
          isParentPage
        />
      </CorporateFieldsProvider>
    </Square>
  );
};
